// removed by extract-text-webpack-plugin
module.exports = {"Container":"src-components-UI-Error-__ErrorCard-module___Container","Content":"src-components-UI-Error-__ErrorCard-module___Content","Icon":"src-components-UI-Error-__ErrorCard-module___Icon","Span":"src-components-UI-Error-__ErrorCard-module___Span"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Error/ErrorCard.module.css
// module id = 1202
// module chunks = 1